module.exports = __webpack_public_path__ + "img/3.ae0cc20f.png";